import React from "react";
// Components
import { UserAccountFormContent } from "../../molecules/Account";
// Constants
import i18nstring, { strings } from "../../../i18n";
// Theme
import ".././OrganismStyles.scss";

export default function UserAccountForm(props) {
  return (
    <div className="modal_main">
      <div className="modal_header">{i18nstring(strings.ACCOUNT_CREATION)}</div>
      <div className="modal_content">
        <UserAccountFormContent
          handleNext={props.handleNext}
          inputs={props.inputs}
        />
      </div>
    </div>
  );
}
